// extracted by mini-css-extract-plugin
export default {"section":"Contacto_section__L-FPl","form":"Contacto_form__e3eKJ","row":"Contacto_row__OOkVo"};